import {
  LayoutDashboard,
  Users,
  Image,
  CreditCard,
  MessageSquare,
  Settings
} from "lucide-react";

import { NavLink } from "react-router-dom";

export default function AdminSidebar() {

  const menus = [
    {
      name: "Dashboard",
      path: "/amd/ms",
      icon: LayoutDashboard
    },
    {
      name: "Users",
      path: "/amd/ms/users",
      icon: Users
    },
    {
      name: "Optimizations",
      path: "/amd/ms/optimizations",
      icon: Image
    },
    {
      name: "Payments",
      path: "/amd/ms/payments",
      icon: CreditCard
    },
    {
      name: "Support",
      path: "/amd/ms/support",
      icon: MessageSquare
    },
    {
      name: "Settings",
      path: "/amd/ms/settings",
      icon: Settings
    }
  ];

  return (
    <div className="w-[260px] bg-gradient-to-b from-[#081b4d] to-[#03122f] min-h-screen text-white flex flex-col">

      {/* Logo */}

      <div className="p-6 border-b border-white/10">
        <h2 className="text-3xl font-bold">
          ShipLess AI
        </h2>

        <p className="text-slate-300 text-sm">
          Admin Panel
        </p>
      </div>

      {/* Menu */}

      <div className="flex-1 p-4 space-y-2">

        {menus.map((item) => {

          const Icon = item.icon;

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-4 rounded-xl transition ${
                  isActive
                    ? "bg-purple-600 text-white"
                    : "hover:bg-white/10"
                }`
              }
            >
              <Icon size={20} />

              <span>
                {item.name}
              </span>
            </NavLink>
          );
        })}
      </div>

      {/* Admin User */}

      <div className="p-4 border-t border-white/10">

        <div className="flex items-center gap-3">

          <img
            src="https://i.pravatar.cc/100"
            alt=""
            className="w-12 h-12 rounded-full"
          />

          <div>
            <h4 className="font-semibold">
              Admin
            </h4>

            <p className="text-xs text-slate-300">
              admin@shipless.in
            </p>
          </div>
        </div>

      </div>

    </div>
  );
}